/** Workers / Assets resolve from public/cesium (see scripts/copy-cesium-assets.cjs). */

export function isShopifyAppPath(pathname = typeof window !== 'undefined' ? window.location.pathname : '') {
  return String(pathname || '').startsWith('/shopify');
}

export function ensureCesiumBaseUrl() {
  if (typeof window === 'undefined') return;
  if (typeof window.CESIUM_BASE_URL === 'string' && window.CESIUM_BASE_URL) return;
  const prefix = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  window.CESIUM_BASE_URL = `${prefix}/cesium/`.replace(/([^:]\/)\/+/g, '$1');
}
